import { useDraggable } from '@dnd-kit/core';
import { Badge } from 'react-bootstrap';
import { RoleId } from './role-id';

export type TagBadgeData = {
  id: RoleId;
  text: string;
  background: string;
  textColor: string;
  draggable?: boolean;
};
export const TagBadge = ({ id, text, background, textColor, draggable = true }: TagBadgeData) => {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: id,
  });

  const style = transform
    ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
      }
    : undefined;

  return draggable ? (
    <Badge
      id={id}
      key={id}
      ref={setNodeRef}
      bg={background}
      text={textColor}
      style={style}
      {...attributes}
      {...listeners}
    >
      {text}
    </Badge>
  ) : (
    <Badge id={id} key={id} bg={background} text={textColor} style={style}>
      {text}
    </Badge>
  );
};
